import React, { useEffect, useState } from 'react';
import { sportsApi } from './sportsApi';

function AppGuide({ app, sources, busy, onSave, focused }) {
  const [source, setSource] = useState(app.binding.source || '');
  const [settleMs, setSettleMs] = useState(app.binding.settleMs ?? 3000);
  const [confirmWithEnter, setConfirmWithEnter] = useState(app.binding.confirmWithEnter !== false);
  const [digitDelayMs, setDigitDelayMs] = useState(app.binding.digitDelayMs ?? 250);
  return <form className="sports-fixtures__card" onSubmit={(event) => {
    event.preventDefault(); onSave(app, { source, settleMs: Number(settleMs), digitDelayMs: Number(digitDelayMs), confirmWithEnter });
  }}>
    <h4>{app.appName}</h4><p>{app.deviceName}{app.screenName && app.screenName !== app.deviceName ? ` · ${app.screenName}` : ''}</p>
    <div className="sports-fixtures__filters sports-calendar__catalogue-filters">
      <label>Programme guide <select autoFocus={focused} disabled={busy} value={source} onChange={(event) => setSource(event.target.value)}>
        <option value="">No guide connected</option>{sources.map((entry) => <option key={`${entry.kind}:${entry.id}`} value={`${entry.kind}:${entry.id}`}>{entry.label}</option>)}
      </select></label>
      <label>Wait after launch (seconds) <input type="number" min="0" max="30" step="0.1" required disabled={busy} value={Number(settleMs) / 1000} onChange={(event) => setSettleMs(Number(event.target.value) * 1000)} /></label>
      <label className="sports-fixtures__confirm"><input type="checkbox" disabled={busy} checked={confirmWithEnter} onChange={(event) => setConfirmWithEnter(event.target.checked)} />Press Enter after the number</label>
      <label>Delay between digits (seconds) <input type="number" min="0" max="2" step="0.05" required disabled={busy} value={Number(digitDelayMs) / 1000} onChange={(event) => setDigitDelayMs(Number(event.target.value) * 1000)} /></label>
      <button type="submit" disabled={busy}>Save app guide</button>
    </div>
  </form>;
}
export default function PlaybackSetup({ siteId, deviceId, focusAppKey }) {
  const [data, setData] = useState({ apps: [], sources: [] });
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    if (!deviceId) return undefined;
    let active = true; const controller = new AbortController();
    setLoading(true); setError('');
    sportsApi(siteId, `playback/${deviceId}/options`, { signal: controller.signal }).then((result) => { if (active) setData(result); })
      .catch((failure) => { if (active) setError(failure.message); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [siteId, deviceId, reload]);
  const save = async (app, binding) => {
    setBusy(true); setError(''); setMessage('');
    try {
      await sportsApi(siteId, `playback/${deviceId}/apps/${encodeURIComponent(app.packageName || `assigned-${app.profileId}`)}`, {
        method: 'PUT', body: { ...binding, revision: app.revision, appDeviceId: app.deviceId },
      });
      setMessage('App guide saved. Watch Now uses the channel numbers from the EPG and your saved input and keypad controls.');
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); setReload((value) => value + 1); }
  };
  return <section aria-label="App guides" className="sports-fixtures__browser">
    <h3>App guides & Watch Now</h3><p>Choose a guide for each enabled app. Your venue’s selected channels appear in On Now; keypad numbers come directly from their guide. Launch rules stay in Site Control / Apps.</p>
    {!deviceId ? <p>Select a TV or box at the top to connect its app guides.</p> : <>
      {loading && <p role="status">Loading enabled apps…</p>}{error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
      {!loading && !data.apps.length && <p>No enabled, launchable apps were found. Tick the required apps under Settings → Edit Device.</p>}
      {!loading && data.apps.map((app) => <AppGuide key={`${app.key}:${app.revision}`} app={app} sources={data.sources} busy={busy} onSave={save} focused={app.key === focusAppKey} />)}
      <button type="button" disabled={busy || loading} onClick={() => setReload((value) => value + 1)}>Reload app guides</button>
    </>}
  </section>;
}
